export class WorkFlowManageWorkOrderParametersDto {
    communityId: number;
    workflowId: number;
    workOrderIdsToLink: Array<number>;
    workOrderIdsToUnLink: Array<number>;
}
